import React from 'react';
import UOMsTable from '../components/UomTable';

export function UOMs() {
  return <UOMsTable />;
}
